<div class="main-section-container">
 
    <div class="modal-body p-0">
        <h6>Deleting the entry?</h6>
        <p>Are sure you want to delete this entry?</p>
        <div class="d-flex align-items-center justify-content-center my-2">
            <button class="btn btn-primary me-2" (click)="close(true)">Delete</button>
            <button class="btn btn-cancel" (click)="close(false)">Cancel</button>
        </div>
    </div>
</div>